import React from 'react';
import LinkBox from "../../components/LinkBox";

import './illustrations.css'
import {SEO} from "../../components/SEO";

function Index() {
    return (
        <div className="illustrations">
            <SEO isDefault />
            <nav className={'flex flex-wrap justify-between'}>
                <h2 className={'text-2xl w-full flex items-center justify-center md:text-4xl font-raleway text-yellow-500 font-bold section'}>Coming Soon...</h2>
                {/*<LinkBox className={'half'} text={'CIRCLE LAN'} img={'illustrations-circle_lan'} link={'/illustrations/circle-lan'} />*/}
                {/*<LinkBox className={'half'} text={'OTHERS'} img={'illustrations-others'} link={'/illustrations/others'} />*/}
            </nav>
        </div>
    );
}

export default Index;